import { useEffect, useState } from "react";

export const useIsWebDriver = () => {
  const [webDriver, setWebDriver] = useState(false);

  useEffect(() => {
    if (isWebDriver()) {
      setWebDriver(true);
    }
  }, []);

  return webDriver;
};

export const isWebDriver = () =>
  typeof navigator !== "undefined" && navigator.webdriver;
